import { delay } from 'rxjs/operators';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NbThemeService } from '@nebular/theme';

declare const echarts: any;

@Component({
  selector: 'ngx-electricity-chart',
  styleUrls: ['./electricity-chart.component.scss'],
  template: `
    <div echarts [options]="option" class="echart"></div>
  `,
})
export class ElectricityChartComponent implements AfterViewInit, OnDestroy {

  option: any;
  data: Array<any>;
  themeSubscription: any;

  constructor(private theme: NbThemeService) {

    const points = [490, 490, 495, 500, 505, 510, 520, 530, 550, 580, 630,
      720, 800, 840, 860, 870, 870, 860, 840, 800, 720, 200, 145, 130, 130,
      145, 200, 570, 635, 660, 670, 670, 660, 630, 580, 460, 380, 350, 340,
      340, 340, 340, 340, 340, 340, 340, 340];

    // const points = [];
    // let pointsCount = 100;
    // let min = -3;
    // let max = 3;
    // let xStep = (max - min) / pointsCount;
    //
    // for(let x = -3; x <= 3; x += xStep) {
    //   let res = x**3 - 5*x + 17;
    //   points.push(Math.round(res * 25));
    // }

    this.data = points.map((p, index) => ({
      label: (index % 5 === 3) ? `${Math.round(index / 5)}` : '',
      value: p,
    }));
  }

  ngAfterViewInit(): void {
    this.themeSubscription = this.theme.getJsTheme().pipe(delay(1)).subscribe(config => {
      const eTheme: any = config.variables.electricity;
      var posList = [
        'left', 'right', 'top', 'bottom',
        'inside',
        'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
        'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
    ];
    
    let appconfigParameters = {
        rotate: {
            min: -90,
            max: 90
        },
        align: {
            options: {
                left: 'left',
                center: 'center',
                right: 'right'
            }
        },
        verticalAlign: {
            options: {
                top: 'top',
                middle: 'middle',
                bottom: 'bottom'
            }
        },
        position: {
            options: echarts.util.reduce(posList, function (map, pos) {
                map[pos] = pos;
                return map;
            }, {})
        },
        distance: {
            min: 0,
            max: 100
        }
    };
    
    let appconfig = {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15
    };
      var labelOption = {
        normal: {
            show: true,
            position: appconfig.position,
            distance: appconfig.distance,
            align: appconfig.align,
            verticalAlign: appconfig.verticalAlign,
            rotate: appconfig.rotate,
            formatter: '{c}  {name|{a}}',
            fontSize: 16,
            rich: {
                name: {
                    textBorderColor: '#fff'
                }
            }
        }
    };
      this.option = {
        color: ['#003366', '#006699', '#4cabce', '#e5323e'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            data: ['Forest', 'Steppe', 'Desert', 'Wetland']
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: {show: true},
                dataView: {show: true, readOnly: false},
                magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                restore: {show: true},
                saveAsImage: {show: true}
            }
        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                axisTick: {show: false},
                data: ['2015', '2016','2017']
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [
            {
                name: 'Forest',
                type: 'bar',
                barGap: 0,
                label: labelOption,
                data: [301, 334, 390]
            },
            {
                name: 'Steppe',
                type: 'bar',
                label: labelOption,
                data: [191, 234, 290]
            },
            {
                name: 'Desert',
                type: 'bar',
                label: labelOption,
                data: [201, 154, 190]
            },
            {
                name: 'Wetland',
                type: 'bar',
                label: labelOption,
                data: [101, 99, 40]
            }
        ]
    };
      // this.option = {
      //     grid: {
      //       left: 0,
      //       top: 0,
      //       right: 0,
      //       bottom: 80,
      //     },
      //     tooltip: {
      //       trigger: 'axis',
      //       axisPointer: {
      //         type: 'line',
      //         lineStyle: {
      //           color: eTheme.tooltipLineColor,
      //           width: eTheme.tooltipLineWidth,
      //         },
      //       },
      //       textStyle: {
      //         color: eTheme.tooltipTextColor,
      //         fontSize: 20,
      //         fontWeight: eTheme.tooltipFontWeight,
      //       },
      //       position: 'top',
      //       backgroundColor: eTheme.tooltipBg,
      //       borderColor: eTheme.tooltipBorderColor,
      //       borderWidth: 3,
      //       formatter: '{c0} kWh',
      //       extraCssText: eTheme.tooltipExtraCss,
      //     },
      //     xAxis: {
      //       type: 'category',
      //       boundaryGap: false,
      //       offset: 25,
      //       data: this.data.map(i => i.label),
      //       axisTick: {
      //         show: false,
      //       },
      //       axisLabel: {
      //         color: eTheme.xAxisTextColor,
      //         fontSize: 18,
      //       },
      //       axisLine: {
      //         lineStyle: {
      //           color: eTheme.axisLineColor,
      //           width: '2',
      //         },
      //       },
      //     },
      //     yAxis: {
      //       boundaryGap: [0, '5%'],
      //       axisLine: {
      //         show: false,
      //       },
      //       axisLabel: {
      //         show: false,
      //       },
      //       axisTick: {
      //         show: false,
      //       },
      //       splitLine: {
      //         show: true,
      //         lineStyle: {
      //           color: eTheme.yAxisSplitLine,
      //           width: '1',
      //         },
      //       },
      //     },
      //     series: [
      //       {
      //         type: 'line',
      //         smooth: true,
      //         symbolSize: 20,
      //         itemStyle: {
      //           normal: {
      //             opacity: 0,
      //           },
      //           emphasis: {
      //             color: '#ffffff',
      //             borderColor: eTheme.itemBorderColor,
      //             borderWidth: 2,
      //             opacity: 1,
      //           },
      //         },
      //         lineStyle: {
      //           normal: {
      //             width: eTheme.lineWidth,
      //             type: eTheme.lineStyle,
      //             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //               offset: 0,
      //               color: eTheme.lineGradFrom,
      //             }, {
      //               offset: 1,
      //               color: eTheme.lineGradTo,
      //             }]),
      //             shadowColor: eTheme.lineShadow,
      //             shadowBlur: 6,
      //             shadowOffsetY: 12,
      //           },
      //         },
      //         areaStyle: {
      //           normal: {
      //             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //               offset: 0,
      //               color: eTheme.areaGradFrom,
      //             }, {
      //               offset: 1,
      //               color: eTheme.areaGradTo,
      //             }]),
      //           },
      //         },
      //         data: this.data.map(i => i.value),
      //       },

      //       {
      //         type: 'line',
      //         smooth: true,
      //         symbol: 'none',
      //         lineStyle: {
      //           normal: {
      //             width: eTheme.lineWidth,
      //             type: eTheme.lineStyle,
      //             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //               offset: 0,
      //               color: eTheme.lineGradFrom,
      //             }, {
      //               offset: 1,
      //               color: eTheme.lineGradTo,
      //             }]),
      //             shadowColor: eTheme.shadowLineDarkBg,
      //             shadowBlur: 14,
      //             opacity: 1,
      //           },
      //         },
      //         data: this.data.map(i => i.value),
      //       },
      //     ],
      //   };
    });
  }

  ngOnDestroy() {
    //this.themeSubscription && 
    this.themeSubscription.unsubscribe();
  }
}
